import { IMachine } from 'model/batch/iMachineTypes';
import { Machine } from 'model/batch/machine';
import axios from './axios';

export async function fetchMachines(): Promise<Machine[]> {
  const response = await axios.get<IMachine[]>('/v1/machines/resume');
  return response.data.map(machine => new Machine(machine));
}
